import { render, staticRenderFns } from "./MobileShell.vue?vue&type=template&id=116da8d8&scoped=true"
import script from "./MobileShell.vue?vue&type=script&lang=js"
export * from "./MobileShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116da8d8",
  null
  
)

export default component.exports